export default __webpack_public_path__ + "static/pic-8abc179c2cbbd76955de1361b7e3e98c.jpg";